module.exports = __webpack_public_path__ + "media/images/steps/step_8-0f30ad5a9f27c75f85f24f219a5c7061.svg";